import React, { useState } from 'react'
import { motion } from 'motion/react';
import { Link } from 'react-router-dom';

type FAQItem = {
  id: number;
  question: string;
  answer: string;
};

const faqData: FAQItem[] = [
  {
    id: 1,
    question: "Who is John Bostjancic?",
    answer:
      "John Bostjancic is an accomplished CFO with deep expertise in financial leadership, specializing in the healthcare and medical device sectors, driving growth and strategic innovation..",
  },
  {
    id: 2,
    question: "What are John Bostjancic’s areas of expertise?",
    answer:
      "John Bostjancic is a finance expert in investor relations, risk management, organizational transformation, and innovation.",
  },
  {
    id: 3,
    question: "How much experience does John Bostjancic have?",
    answer:
      "With more than 30 years of experience in finance, John Bostjancic has held leadership positions across various industries.",
  },
  {
    id: 4,
    question: "What industries has John Bostjancic worked in?",
    answer:
      "His expertise covers healthcare, medical devices, and other sectors demanding high-level financial leadership.",
  },
  // {
  //   id: 5,
  //   question: "Is John Bostjancic available for consulting?",
  //   answer:
  //     "Yes, he is available for interim CFO roles and consulting projects.",
  // },
  // {
  //   id: 6,
  //   question: "What is John Bostjancic’s leadership style?",
  //   answer:
  //     "John is known for his operational focus, strategic thinking, and commitment to mentoring and innovation.",
  // },
  // {
  //   id: 7,
  //   question: "Where is John Bostjancic based?",
  //   answer: "He currently resides in Carlsbad, California.",
  // },
];

const Questions = () => {
  const [activeId, setActiveId] = useState<number | null>(null);

  const toggleFAQ = (id: number) => {
    setActiveId(activeId === id ? null : id); // Toggle active state
  };
  return (
    <div className="max-w-screen-2xl mx-auto">
      <div className="bg-[#F8F9FF] sm:rounded-tl-[250px] px-5 sm:px-20 py-10 sm:py-28">
        <div className="flex flex-col sm:flex-row gap-10">
          <div className=" flex flex-col justify-center sm:w-[45%]">
            <div className="relative mb-9">
              <motion.h3
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="poppins-regular text-primary z-20 relative"
              >
                FREQUENTLY ASKED QUESTIONS
              </motion.h3>
              <div className="size-16 bg-[#ffff] rounded-full absolute -top-5 -left-5"></div>
            </div>
            <motion.h2
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="text-secondary text-3xl sm:text-[40px] mb-4"
            >
              HAVE ANY QUESTION ON MIND ?
            </motion.h2>
            <motion.p
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 1 }}
              viewport={{ once: true }}
              className="text-secondary mb-4 sm:mb-8"
            >
              With 30+ years in healthcare finance, I provide expert services
              that drive growth, enhance stability, and foster innovation,
              helping organizations thrive in the medical
            </motion.p>
            <Link to="/faq" onClick={() => window.scrollTo(0, 0)}>
              <div className="flex gap-3 text-primary montserrat-semibold items-center">
                Read More{" "}
                <svg
                  width="26"
                  height="18"
                  viewBox="0 0 26 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="fill-primary"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.8387 9.81254C25.0377 10.0118 25.1494 10.2818 25.1494 10.5634C25.1494 10.8449 25.0377 11.115 24.8387 11.3142L16.3387 19.8142C16.2414 19.9186 16.1241 20.0023 15.9938 20.0604C15.8634 20.1185 15.7228 20.1497 15.5801 20.1522C15.4374 20.1547 15.2957 20.1285 15.1634 20.075C15.0311 20.0216 14.9109 19.9421 14.81 19.8412C14.7092 19.7403 14.6296 19.6201 14.5762 19.4878C14.5227 19.3555 14.4965 19.2138 14.499 19.0711C14.5015 18.9285 14.5328 18.7878 14.5908 18.6574C14.6489 18.5271 14.7326 18.4098 14.837 18.3125L21.5237 11.6259L1.42118 11.6259C1.13939 11.6259 0.869138 11.5139 0.669881 11.3147C0.470623 11.1154 0.358682 10.8452 0.358682 10.5634C0.358682 10.2816 0.470623 10.0113 0.669881 9.81207C0.869138 9.61281 1.13939 9.50087 1.42118 9.50087L21.5237 9.50087L14.837 2.8142C14.7326 2.71693 14.6489 2.59963 14.5908 2.4693C14.5328 2.33896 14.5015 2.19827 14.499 2.05561C14.4965 1.91295 14.5227 1.77124 14.5762 1.63894C14.6296 1.50664 14.7092 1.38646 14.81 1.28556C14.9109 1.18467 15.0311 1.10513 15.1634 1.05169C15.2957 0.998256 15.4374 0.972013 15.5801 0.97453C15.7228 0.977047 15.8634 1.00827 15.9938 1.06634C16.1241 1.12442 16.2414 1.20814 16.3387 1.31253L24.8387 9.81254Z"
                    fill="primary"
                  />
                </svg>
              </div>
            </Link>
          </div>
          <div className="sm:w-[60%]">
            {faqData.map((item) => (
              <div
                key={item.id}
                className="border rounded-lg mb-4 border-black overflow-hidden shadow-sm"
              >
                {/* Question */}
                <button
                  onClick={() => toggleFAQ(item.id)}
                  className={`w-full text-left p-6 montserrat-medium text-lg flex justify-between items-center transition-all duration-300 ${
                    activeId === item.id
                      ? "bg-primary text-white"
                      : "bg-transparent text-secondary"
                  }`}
                >
                  {item.question}
                  <span className="text-xl montserrat-regular">
                    {activeId === item.id ? "−" : "+"}
                  </span>
                </button>

                {/* Answer */}
                {activeId === item.id && (
                  <div className="p-4  text-secondary montserrat-regular ">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Questions